import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'

import Container from 'components/Container'
import VanillaFAQ from 'components/FAQ'

export interface FAQProps {
  image?: IGatsbyImageData
  extraQuestions?: Queries.FAQInfoFragment[]
  ignoreGlobalFaq?: boolean
  disableContactOptions?: boolean
}

const FAQ = ({ image, extraQuestions, ignoreGlobalFaq, disableContactOptions }: FAQProps) => {
  const queryResult = !ignoreGlobalFaq
    ? useStaticQuery<Queries.FaqGlobalQuery>(graphql`
        query FaqGlobal {
          strapiGlobal {
            faq {
              ...FAQInfo
            }
          }
        }
      `)
    : undefined

  const strapiGlobal = queryResult?.strapiGlobal || undefined

  return (
    <Container>
      <VanillaFAQ
        image={image}
        questions={strapiGlobal ? (strapiGlobal.faq as Queries.FAQInfoFragment[]) : undefined}
        extraQuestions={extraQuestions}
        disableContactOptions={disableContactOptions}
      />
    </Container>
  )
}

export const query = graphql`
  fragment FAQInfo on STRAPI__COMPONENT_SHARED_FAQ {
    id
    question
    answer {
      data {
        childMarkdownRemark {
          id
          html
        }
      }
    }
  }
`

export default FAQ
